// src/components/layout/Header.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../../../stores/useAppStore';
import logo from '../../../assets/logo.png';
import './styles.scss';
import AtlasAvatar from '../../ui/avatar';

export default function Header({ type = null }) {
  const currentUser = useAppStore(state => state.currentUser);
  const logout = useAppStore(state => state.logout);

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const menuRef = useRef(null);

  const username =
    currentUser?.username ||
    currentUser?.user?.username ||
    currentUser?.name ||
    '';

  const namePart = username.includes('@')
    ? username.split('@')[0]
    : username;

  const initials =
    (namePart || 'DS')
      .split(/[\s._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(s => s[0]?.toUpperCase())
      .join('') || 'DS';

  const handleLogout = () => {
    logout();
    navigate('', { replace: true });
  };

  useEffect(() => {
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  return (
    <>
    <header className="em-header">
      {/* LEFT */}
      <div className="em-header__left">
        <img src={logo} alt="logo" onClick={() => navigate('/')} />
      </div>

      {/* CENTER NAV */}
      <div className="em-header__center">
        {type === 'landing' && <nav className="header-nav">
          <button onClick={() => navigate('/docs')} className="nav-link">
            Docs
          </button>
          <button onClick={() => navigate('/security')} className="nav-link">
            Security
          </button>
          <button onClick={() => navigate('/support')} className="nav-link">
            Support
          </button>
          <button onClick={() => navigate('/blog/people-signal-graph')} className="nav-link">
            Blog
          </button>
          <button onClick={() => navigate('/about')} className="nav-link">
            About
          </button>
        </nav>}
      </div>

      {/* RIGHT */}
      <div className="em-header__right">
      {type === 'landing' && (
        <button className="mobile-hamburger" onClick={() => setMobileNav(prev => !prev)} aria-label="Menu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {mobileNav ? (
              <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
            ) : (
              <><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/></>
            )}
          </svg>
        </button>
      )}
      {currentUser ? (
        <div className="header-user-menu" ref={menuRef}>
          <button
            className="avatar-btn"
            onClick={() => setOpen(prev => !prev)}
            aria-haspopup="true"
            aria-expanded={open}
          >
            <span>{initials}</span>
          </button>

          {open && (
            <div className="header-dropdown" role="menu">
              <div className="header-dropdown__top">
                <div className="name">{username}</div>
                <div className="role">
                  {currentUser?.isAdmin ? 'Admin ' : ''}
                  {currentUser?.isManager ? 'Manager' : ''}
                </div>
              </div>
              <button
                className="dropdown-item danger"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      ) : (
        <AtlasAvatar />
      )}
      </div>
    </header>

    {type === 'landing' && mobileNav && (
      <div className="mobile-nav-overlay" onClick={() => setMobileNav(false)}>
        <nav className="mobile-nav" onClick={e => e.stopPropagation()}>
          <button onClick={() => { navigate('/docs'); setMobileNav(false); }} className="mobile-nav-link">Docs</button>
          <button onClick={() => { navigate('/security'); setMobileNav(false); }} className="mobile-nav-link">Security</button>
          <button onClick={() => { navigate('/support'); setMobileNav(false); }} className="mobile-nav-link">Support</button>
          <button onClick={() => { navigate('/blog/people-signal-graph'); setMobileNav(false); }} className="mobile-nav-link">Blog</button>
          <button onClick={() => { navigate('/about'); setMobileNav(false); }} className="mobile-nav-link">About</button>
        </nav>
      </div>
    )}
    </>
  );
}
